export default {
	ERRO_DEFAULT: 'Ocorreu um erro ao realizar a operação.',
	SUCESSO_DEFAULT: 'Operação realizada com sucesso.',
}
